import React, { useState, useEffect, useCallback } from 'react';
import {
  convertDecimalToCurrency,
  convertCurrencyToDecimal,
  handleCurrencyChange,
} from '../AggregatedCohortTable/utils';

interface UseCurrencyFormatOptions {
  value: number | null;
  onChange?: (value: number | null) => void;
}

const useCurrencyFormat = ({ value, onChange }: UseCurrencyFormatOptions) => {
  const [formattedValue, setFormattedValue] = useState(
    value !== null ? convertDecimalToCurrency(value) : '',
  );

  useEffect(() => {
    setFormattedValue(value !== null ? convertDecimalToCurrency(value) : '');
  }, [value]);

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      const inputValue = e.target.value;

      if (formattedValue === '-$' && inputValue === '-') {
        setFormattedValue('');
        onChange?.(null);
        return;
      }

      if (inputValue === '-') {
        setFormattedValue('-$');
        onChange?.(null);
        return;
      }

      if (inputValue === '' || inputValue === '$') {
        setFormattedValue('');
        onChange?.(null);
        return;
      }

      const newActualValue = convertCurrencyToDecimal(inputValue);
      handleCurrencyChange(e, setFormattedValue);
      onChange?.(newActualValue);
    },
    [onChange, formattedValue],
  );

  return { formattedValue, handleChange };
};

export default useCurrencyFormat;
